import { motion } from "framer-motion"

const Reveal = ({ children, delay = 0, y = 40, as = "div", className = "", ...rest }) => {
  const Component = motion[as]
  return (
    <Component
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </Component>
  )
}

export const SectionLabel = ({ index, children, light = false }) => (
  <div className={`k-label ${light ? "k-label--light" : ""}`}>
    <span className="k-label__index">{index}</span>
    <span className="k-label__line" />
    <span>{children}</span>
  </div>
)

export default Reveal
